module.exports = __webpack_public_path__ + "static/project-11b-4102fcaf2e7470efb2d10890cd05aa01.png";